import { render, staticRenderFns } from "./BillingInformationsForm.vue?vue&type=template&id=4f62c85c"
import script from "./BillingInformationsForm.vue?vue&type=script&lang=js"
export * from "./BillingInformationsForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports